<template>
    <div class="jump-cart">
        <van-nav-bar title="设置发货数量" left-arrow fixed class="jump-nav-bar" @click-left="back" v-if="type=='fh'"/>
        <van-nav-bar title="设置赠送数量" left-arrow fixed class="jump-nav-bar" @click-left="back" v-if="type=='zs'"/>
        <div class="jump-cart-body">
            <div class="jump-cart-body-hd"></div>
            <van-row class="jump-cart-item" type="flex" v-for="(item,index) in orderGoods">
                <van-col span="24">
                    <p><span style="font-size: 16px">商品名称：</span>{{item.goods_name}}</p>
                    <p><span style="font-size: 16px">订货数量：</span>{{item.count}}</p>
                   <p v-if="item.spec&&item.spec!=''"><span style="font-size: 16px">规格：</span>{{item.spec}}</p>

                    <p v-if="type=='fh'&&workFlow.workflowType!=10">
                        <span style="font-size: 16px">单价：</span>{{item.price * (item.discount==null?1:item.discount)}}

                    </p>
                    <p v-if="type=='fh'&&workFlow.workflowType==10">
                        <span style="font-size: 16px" >单价：</span>
                        <van-field v-model="price[index]" placeholder="请输入单价" 
                                   style="display: inline-flex;width: 200px" :disabled="flowFlag==1"/>
                    </p>
                    <p v-if="type=='fh'"><span style="font-size: 16px">小计：</span>{{item.minSum}}</p>
                    <p><span style="font-size: 16px">销售单位：</span>{{item.goods_unit_seller}}</p>
                    <p v-if="type=='fh'"><span style="font-size: 16px">赠送数量：</span>{{item.give_count}}</p>
                    <p v-if="type=='fh'"><span style="font-size: 16px">未出库数量：</span>{{item.none_delivery_goods_count}}
                    </p>
                    <!--<p><span>品牌：</span>{{item.}}</p>-->
                    <p><span style="font-size: 16px">促销活动：</span>{{item.pname}}</p>
                    <p><span style="font-size: 16px" v-if="type=='fh'">发运数量：</span>
                        <span style="font-size: 16px" v-if="type=='zs'">赠送数量：</span>
                        <van-field v-model="num[index]" placeholder="请输入发运数量"
                                   style="display: inline-flex;width: 200px"/>
                    </p>
                    <p v-if="workFlow.workflowType==10 && userRole.indexOf('TM')!=-1 && data.isTmDealOne">
                        <van-field
                                v-model="contractList[index]"
                                readonly
                                label="执行合同"
                                :disabled="flowFlag==1"
                                placeholder="请选择执行合同"
                                @focus="contractShow(item,index)"
                                style="font-size: 16px;margin-left: -10px;"
                        />
                    </p>
                </van-col>

            </van-row>
            <!-- 执行合同 -->
            <van-popup v-model="contracthow" position="bottom" :overlay="true">
                <van-picker
                        :columns="columns"
                        show-toolbar
                        value-key="name"
                        @cancel="gcontractCancel"
                        @confirm="contractConfirm"
                        @change="contractChange"
                />
            </van-popup>
            <div class="usercenter-button">
                <van-button size="large" @click="saveShip">提 交</van-button>
            </div>
        </div>
    </div>
</template>
<script>
    import {NavBar, Row, Col, Cell, List, Field, Button, Picker, Popup} from "vant";

    export default {
        name: "userhistory",
        components: {
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [Button.name]: Button,
            [Cell.name]: Cell,
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Field.name]: Field,
            [List.name]: List
        },
        data() {
            return {
                userRole: localStorage.getItem("userRole"),
                type: this.$route.query.type,
                flowFlag:this.$route.query.flowFlag,
                id: this.$route.query.id,
                orderGoods: [],
                data: {},
                num: [],
                contractList: [],//执行合同
                list:[],
                columns: [],
                contractcolumns:[],
                contracthow: false,
                contractindex: 0,
                price:[],
            };
        }, mounted: function () {
            this.selAuditedDetailInfo()
        },
        methods: {
            back() {
                history.back();
            }, selAuditedDetailInfo() {
                let that = this;
                this.$api.post(that.jumuc.userCenter.selAuditedDetailInfo,
                    {'workFlowId': that.id, 'flag': true},
                    successRes => {
                        that.orderGoods = successRes.data.orderGoods
                        that.data = successRes.data
                        that.workFlow = successRes.data.workFlow
                        for (var i = 0; i < that.orderGoods.length; i++) {
                            that.price[i] = that.orderGoods[i].price*(that.orderGoods[i].discount==null?1:that.orderGoods[i].discount)
                            if (that.type == 'fh') {
                                that.num[i] = that.orderGoods[i].shipment_count
                            }
                            if (that.type == 'zs') {
                                that.num[i] = 0
                            }
                            //执行合同
                            try {
                                let id= successRes.data.orderGoods[i].contract_manage_id
                               that.list[i]=id
                                let contract = successRes.data.orderGoods[i].contractList
                                let contractlist = []
                                for (var j = 0; j < contract.length; j++) {
                                    let json = {}
                                    json['id'] = contract[j].id
                                    json['name'] = contract[j].contractName
                                    
                                    json['price'] = contract[j].price
                                    json['daysPrice'] = contract[j].daysPrice
                                    contractlist[j] = json
                                    if(id==contract[j].id){
                                        id=contract[j].contractName
                                    }
                                }
                                that.contractList[i]=id
                                that.contractcolumns[i]=contractlist
                                if(i==0){
                                    that.columns=that.contractcolumns[0]
                                }
                            } catch (e) {
                            }
                        }

                    })
            }, saveShip() {
                let that = this;
                let ship = []
                let json = {}
                if (that.type == 'fh') {
                    for (var i = 0; i < that.num.length; i++) {
                        json={};
                        json['goodsCartId'] = that.orderGoods[i].cart_id
                        json['shipNum'] = that.num[i]
                        json['tmPrice'] = that.price[i]
                        json['contractId'] = that.list[i]
                        ship.push(json)
                    }
                    this.$api.post(that.jumuc.userCenter.saveShip,
                        {'orderId': that.data.orders.id, 'ship': ship},
                        successRes => {
                            that.$toast(successRes.msg)
                            if (successRes.success) {
                                history.back();
                            }
                        })
                }
                if (that.type == 'zs') {
                    let array=that.num;
                    for (var i = 0; i < array.length; i++) {
                        json={};
                        json['goodscart_id'] = that.orderGoods[i].cart_id
                        json['give_count'] = array[i]
                        json['contractId'] = that.list[i]
                        ship.push(json)
                    }
                    this.$api.post(that.jumuc.userCenter.orderGoodsGiveSave,
                        {'orderId': that.data.orders.id, 'detailData': ship},
                        successRes => {
                            that.$toast(successRes.msg)
                            if (successRes.success) {
                                history.back();
                            }
                        })
                }

            }
            , contractShow(item, index) {//选择执行合同
                let that = this
                that.contractindex = index
                that.columns = that.contractcolumns[index]
                that.contracthow = true
            }, gcontractCancel() {
                let that = this
                that.contracthow = false
            }, contractConfirm(values) {
                let that = this
                that.contractList[that.contractindex] = values.name
                that.list[that.contractindex] = values.id
                that.contracthow = false;
                //重新设置单价
                let obj= that.orderGoods[that.contractindex];
                if(obj.payment==1){//现金
                    that.price[that.contractindex]=values.price
                }else if(obj.payment==2){//账期
                   that.price[that.contractindex]=values.daysPrice
                }
            }, contractChange(picker, values) {
                picker.setColumnValues(1, values)
            }
        }
    };
</script>
<style lang="less">
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-cart {
        .usercenter-button {
            padding: 0 15px;
            button {
                background-color: @bule-thame;
                color: white;
                font-weight: 700;
                border-radius: 5px;
                margin: 25px 0 10px;
            }
        }


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 100%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
                &.item-time {
                    color: @bule-thame;
                    font-size: 16px;
                    text-align: right;
                }
                &.item-price {
                    color: red;
                    font-size: 16px;
                    i {
                        font-size: 18px;
                        float: right;
                        color: #f5a623
                    }
                }
            }
        }
    }
</style>

